import { Component, Host, h, Prop, State } from "@stencil/core";

import { Collapsible } from "../../../../../utils/backend/reply-parsed";
import { fixIEShadowDom } from "../../../../../utils/fix-ie-shadow-dom";

// Future Task read: https://www.w3.org/TR/wai-aria-practices-1.1/examples/disclosure/disclosure-faq.html
@Component({
    tag: "c-bubble-collapsible",
    styleUrl: "c-bubble-collapsible.scss",
})
export class CBubbleCollapsible {
    @Prop() elements: Collapsible[];
    @State() isCollapsed: boolean[] = [];
    // Needed for aria-describedby in feedback component
    @Prop() bubbleId: string;
    @Prop() withFeedback: boolean | undefined;

    connectedCallback() {
        this.isCollapsed = Array(this.elements.length).fill(true);
    }

    toggleCollapsed(index: number) {
        // Allow multiple definitions to be open at the same time
        // this.isCollapsed = [
        //   ...this.isCollapsed.slice(0, index),
        //   !this.isCollapsed[index],
        //   ...this.isCollapsed.slice(index + 1, this.isCollapsed.length),
        // ]
        const update = Array(this.isCollapsed.length).fill(true);
        update[index] = !this.isCollapsed[index];
        this.isCollapsed = update;
    }

    render() {
        return (
            <Host>
                <div
                    class={
                        this.withFeedback
                            ? "bubble-container-with-feedback"
                            : ""
                    }
                >
                    <dl
                        id={this.bubbleId}
                        class={this.withFeedback ? "bubble-with-feedback" : ""}
                    >
                        {this.elements.map((element, index) => {
                            return [
                                <dt key={element.text}>
                                    <button
                                        aria-expanded={
                                            this.isCollapsed[index]
                                                ? "false"
                                                : "true"
                                        }
                                        aria-controls={
                                            this.bubbleId +
                                            "-collapsed-" +
                                            index
                                        }
                                        onClick={() =>
                                            this.toggleCollapsed(index)
                                        }
                                        class={`${
                                            this.isCollapsed[index]
                                                ? "collapsed"
                                                : ""
                                        }`}
                                    >
                                        <span
                                            innerHTML={
                                                fixIEShadowDom(element.text, "c-bubble-collapsible")
                                            }
                                        ></span>
                                    </button>
                                </dt>,
                                <dd
                                    key={element.text}
                                    id={this.bubbleId + "-collapsed-" + index}
                                    class={`${
                                        this.isCollapsed[index]
                                            ? "collapsed"
                                            : ""
                                    }`}
                                    innerHTML={
                                        fixIEShadowDom(element.collapsed, "c-bubble-collapsible")
                                    }
                                ></dd>,
                            ];
                        })}
                    </dl>
                    {this.withFeedback && (
                        <c-feedback bubbleId={this.bubbleId}></c-feedback>
                    )}
                </div>
            </Host>
        );
    }
}
